import getScoreSeverity from 'utils/get-score-severity';

import { PROTECTED_DATA_REGEXP, UNKNOWN } from './constants';
import { Type } from './types';

export function isProtectedData(value: unknown): value is string {
    return typeof value === 'string' && PROTECTED_DATA_REGEXP.test(value);
}

export function assertNumber(value: unknown, options?: { coerce: boolean }) {
    if (options?.coerce) {
        value = Number(value);
    }
    if (typeof value === 'number' && !Number.isNaN(value)) {
        return value;
    }
    throw new Error(`Expected <${value}> to be number`);
}

const types = Object.values(Type);
export function castType(value: unknown) {
    if (typeof value === 'string') {
        for (const type of types) {
            if (type.toLowerCase() === value.toLowerCase()) {
                return type;
            }
        }
    }
    return Type.UNKNOWN;
}

export function parseProtectedData(value: string) {
    const match = value.match(PROTECTED_DATA_REGEXP);
    if (!match) {
        throw new Error('Not a licensed data');
    }
    const type = castType(match.groups?.type);
    const size = assertNumber(match.groups?.size, { coerce: true });
    return { type, size };
}

export function getSeverity(value: string | number, scale?: number) {
    if (isProtectedData(value)) {
        return UNKNOWN;
    } else {
        return getScoreSeverity(value, scale);
    }
}
